import axios, { extractData } from '@atheneum/api'
import { extendObservable } from 'mobx'
import moment from 'moment'

class PaymentsStore {
  constructor (staticData) {
    extendObservable(this, {
      loading: false,
      error: null,
      staticData,
      payments: [],
      noOfPayments: null,
      query: this.getEmptyQuery()
    })
  }

  getEmptyQuery () {
    return {
      startDate: moment()
        .startOf('month')
        .format('YYYY-MM-DD'),
      endDate: moment()
        .endOf('month')
        .format('YYYY-MM-DD')
    }
  }

  filter () {
    this.loading = true
    const url = '/api/payment'
    return axios
      .post(url, this.query)
      .then(res => {
        const responseData = extractData(res)
        this.noOfPayments = responseData.count
        this.payments.replace(responseData)
      })
      .catch(err => {
        this.error = err
      })
      .then(() => {
        this.loading = false
      })
  }

  changePage (page) {
    this.query.page = page
    this.filter()
  }

  clearSearch () {
    this.query = this.getEmptyQuery()
    this.filter()
  }
}

export default PaymentsStore
